import { increaseLoading, decreaseLoading } from 'actionCreators/loading';
import { getStore } from '../redux/store';

export const withLoader = <T = any>(promise: Promise<T>) => {
  increase();
  return promise
    .then((response) => {
      decrease();
      return response;
    })
    .catch((error) => {
      decrease();
      return error;
    });
};

const increase = () => {
  const store = getStore();
  if (!store) return;
  store.dispatch(increaseLoading());
};

const decrease = () => {
  const store = getStore();
  if (!store) return;
  store.dispatch(decreaseLoading());
};
